import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { getCleanPlainText } from "@/shared/utils/accountConfig";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * Name + subtitle (email, designation, etc.) — each stays on one line
 * and truncates with ellipsis to fit the available width.
 */
const ProfileTextStack = ({
  primary,
  secondary,
  primaryClassName,
  secondaryClassName,
  className,
}) => {
  const primaryText = primary != null && primary !== "" ? String(primary) : "";
  const secondaryRaw =
    secondary != null && secondary !== "" ? getCleanPlainText(secondary) : "";
  const secondaryText =
    secondaryRaw != null && secondaryRaw !== "" ? String(secondaryRaw) : "";

  if (!primaryText && !secondaryText) return null;

  return (
    <div
      className={cn(
        "flex min-w-0 flex-1 flex-col gap-0.5 overflow-hidden text-left",
        className,
      )}
    >
      {primaryText ? (
        <p
          className={cn(
            "truncate text-xs font-medium text-gray-800 dark:text-gray-100",
            primaryClassName,
          )}
          title={primaryText}
        >
          {primaryText}
        </p>
      ) : null}
      {secondaryText ? (
        <p
          className={cn(
            "truncate text-[10px] font-normal text-gray-500 dark:text-gray-400",
            secondaryClassName,
          )}
          title={secondaryText}
        >
          {secondaryText}
        </p>
      ) : null}
    </div>
  );
};

export default ProfileTextStack;
